import { createBrowserClient } from "@supabase/ssr";
import { createClient as createSupabaseClient } from "@supabase/supabase-js";

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
}

/**
 * A client whose every request carries the given access token, as is.
 *
 * The shared client asks auth-js for the session before EACH request, and on a
 * browser whose clock runs ahead of the server every token looks expired, so
 * each request refreshes first. A caller making several reads that belong
 * together reads the session once and runs them all through this, so they
 * cost one refresh between them. It has no auth of its own (no storage, no
 * refresh, no auth events); a null token sends the anon key, as the shared
 * client does when signed out.
 */
export function createClientWithAccessToken(accessToken: string | null) {
  return createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { accessToken: async () => accessToken }
  );
}
